import {useFieldContext} from '../../utils/formContext';

import {TextareaInput} from './TextareaInput';

type Props = Omit<React.ComponentProps<typeof TextareaInput>, 'name'>;
export function FormTextareaInput(props: Props): React.JSX.Element {
  const field = useFieldContext<string>();

  return (
    <TextareaInput
      {...props}
      name={field.name}
      value={field.state.value}
      onChange={(e) => field.handleChange(e.target.value)}
      onBlur={field.handleBlur}
      error={field.state.meta.errors.map((e) => e.message).join(', ')}
    />
  );
}
